import React from "react";
import { Badge, Group } from "@mantine/core";

export interface TagsBadgeProps {
  /** Currently selected room type ID */
  value?: string[] | null | undefined;
  /** Size of the selector */
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

export const TagsBadge: React.FC<TagsBadgeProps> = ({ value, size = "xs" }) => {
  // Render the select component
  return (
    Array.isArray(value) && (
      <Group gap="xs" mt="xs">
        {value.slice(0, 3).map((tag, index) => (
          <Badge
            key={index}
            size={size}
            variant="light"
            color="blue"
            style={{ textTransform: "none" }}
          >
            {tag}
          </Badge>
        ))}
        {value.length > 3 && (
          <Badge
            size={size}
            variant="outline"
            color="gray"
            style={{ textTransform: "none" }}
          >
            +{value.length - 3}
          </Badge>
        )}
      </Group>
    )
  );
};
